import { VueConstructor } from 'vue/types/vue';
import CgToastContainer from './CgToastContainer.vue';
import { AlertType, ToastItem, ToastOptions, ToastItemOptions } from './types';

const genId = ((i) => () => i++)(0);

const defaultItemOptions: Required<ToastItemOptions> = {
  hideIcon: false,
  html: false,
};

class ToastApi {
  items: ToastItem[] = [];

  options: ToastOptions = {};

  constructor(Vue: VueConstructor, options: ToastOptions) {
    const container = new (Vue.extend(CgToastContainer))({
      el: document.createElement('div'),
      propsData: {
        toastApi: this,
        ...options,
      }
    });
    document.body.appendChild(container.$el);

    this.options = options;
    this.items = [];
  }

  get itemsList() {
    return this.items ?? [];
  }

  private addItemToList(toastItem : ToastItem): string | number {
    this.items.push(toastItem);

    return toastItem.id;
  }

  success(message: string, options?: ToastItemOptions): string | number {
    const itemOptions = { ...defaultItemOptions, ...options };

    const item: ToastItem = {
      message,
      id: genId(),
      type: AlertType.Success,
      backgroundColor: null,
      ...itemOptions,
    };

    return this.addItemToList(item);
  }

  error(message: string, options?: ToastItemOptions): string | number {
    const itemOptions = { ...defaultItemOptions, ...options };

    const item: ToastItem = {
      message,
      id: genId(),
      type: AlertType.Error,
      backgroundColor: null,
      ...itemOptions,
    };

    return this.addItemToList(item);
  }

  information(message: string, options?: ToastItemOptions): string | number {
    const itemOptions = { ...defaultItemOptions, ...options };

    const item: ToastItem = {
      message,
      id: genId(),
      type: AlertType.Information,
      backgroundColor: null,
      ...itemOptions,
    };

    return this.addItemToList(item);
  }

  warning(message: string, options?: ToastItemOptions): string | number {
    const itemOptions = { ...defaultItemOptions, ...options };

    const item: ToastItem = {
      message,
      id: genId(),
      type: AlertType.Warning,
      backgroundColor: null,
      ...itemOptions,
    };

    return this.addItemToList(item);
  }

  successBold(message: string, options?: ToastItemOptions): string | number {
    const itemOptions = { ...defaultItemOptions, ...options };

    const item: ToastItem = {
      message,
      id: genId(),
      type: AlertType.SuccessBold,
      backgroundColor: null,
      ...itemOptions,
    };

    return this.addItemToList(item);
  }

  errorBold(message: string, options?: ToastItemOptions): string | number {
    const itemOptions = { ...defaultItemOptions, ...options };

    const item: ToastItem = {
      message,
      id: genId(),
      type: AlertType.ErrorBold,
      backgroundColor: null,
      ...itemOptions,
    };

    return this.addItemToList(item);
  }

  dismiss(toastId: string | number): void {
    const itemIndex = this.items?.findIndex((item) => item.id === toastId);
    this.items.splice(itemIndex, 1);
  }

  clear(): void {
    this.items = [];
  }

  // TODO custom with all available props
  // TODO add optional options to overwrite global options like 'timeout'
}

export default ToastApi;
